'use client';

import * as React from 'react';

import { Dashboard } from '@/shared/i18n';
import { Typography } from '@mui/material';
import { LearningPathWrapper } from './learning-path-wrapper';
import { LessonsWrapper } from './lessons-wrapper';
import { EventBus } from '@/shared/utils';
import { DashboardEvents } from 'src/modules/dashboard/events';

interface FavoriteProps {
  isSubscribed: boolean;
  dict: Dashboard;
  eventBus: EventBus<DashboardEvents>;
}

const Favourites: React.FC<FavoriteProps> = ({ isSubscribed, dict, eventBus }) => {
  return (
    <div className="rounded-xl bg-paper p-3 md:px-6 md:py-10 overflow-hidden">
      <div className="space-y-6 text-center">
        <Typography variant="mac-sans-h2" className="mb-1" component="h2">
          {dict.dashboard.favourites.title}
        </Typography>
        <Typography variant="s1" color="textSecondary">
          {dict.dashboard.favourites.description}
        </Typography>
        <div className="space-y-6">
          <LearningPathWrapper dict={dict} eventBus={eventBus} />
          {isSubscribed && <LessonsWrapper dict={dict} eventBus={eventBus} />}
        </div>
      </div>
    </div>
  );
};
export default Favourites;
